export default __webpack_public_path__ + "static/auto-7229c793e7607651119232e276abc0a4.jpg";